module.exports = __webpack_public_path__ + "img/media-19.af53aecb.png";